/** Resolve source/native length, never the audition window or current song tempo. */
export function fullLibraryLoop(loop, duration) {
  const bpm = Number(loop.bpm);
  if (!(bpm > 0) || !Number.isFinite(bpm)) throw new Error('source tempo is missing');
  if (!(duration > 0) || !Number.isFinite(duration)) throw new Error('full audio length is unavailable');
  const measured = duration * bpm / 240;
  const tagged = Number(loop.bars);
  const group = String(loop.instrument_group || '').toLowerCase();
  // FX keep exact file duration. Musical tags can exclude a short export decay tail,
  // but a half-length tag must never truncate the file.
  let bars = measured;
  if (group !== 'fx' && group !== 'sound effects') {
    const phrase = [4, 8].find(n => Math.abs(measured - n) <= Math.max(.025, n * .01));
    if (phrase) bars = phrase;
    else if (tagged > 0 && Math.abs(tagged - measured) <= .5) bars = tagged;
  }
  return { ...loop, bars, bpm, sourceDurationSeconds: duration };
}
